// SPDX-FileCopyrightText: 2017-2026 City of Espoo
//
// SPDX-License-Identifier: LGPL-2.1-or-later

// GENERATED FILE: no manual modifications

import type { BackupPickupId } from 'lib-common/generated/api-types/shared'
import type { ChildBackupPickupContent } from 'lib-common/generated/api-types/backuppickup'
import type { ChildBackupPickupCreateResponse } from 'lib-common/generated/api-types/backuppickup'
import type { ChildBackupPickupsResponse } from 'lib-common/generated/api-types/backuppickup'
import type { JsonCompatible } from 'lib-common/json'
import type { JsonOf } from 'lib-common/json'
import type { PersonId } from 'lib-common/generated/api-types/shared'
import { client } from '../../api/client'
import { uri } from 'lib-common/uri'


/**
* Generated from evaka.core.backuppickup.BackupPickupController.createBackupPickup
*/
export async function createBackupPickup(
  request: {
    childId: PersonId,
    body: ChildBackupPickupContent
  }
): Promise<ChildBackupPickupCreateResponse> {
  const { data: json } = await client.request<JsonOf<ChildBackupPickupCreateResponse>>({
    url: uri`/employee/children/${request.childId}/backup-pickups`.toString(),
    method: 'POST',
    data: request.body satisfies JsonCompatible<ChildBackupPickupContent>
  })
  return json
}


/**
* Generated from evaka.core.backuppickup.BackupPickupController.deleteBackupPickup
*/
export async function deleteBackupPickup(
  request: {
    id: BackupPickupId
  }
): Promise<void> {
  const { data: json } = await client.request<JsonOf<void>>({
    url: uri`/employee/backup-pickups/${request.id}`.toString(),
    method: 'DELETE'
  })
  return json
}


/**
* Generated from evaka.core.backuppickup.BackupPickupController.getBackupPickups
*/
export async function getBackupPickups(
  request: {
    childId: PersonId
  }
): Promise<ChildBackupPickupsResponse> {
  const { data: json } = await client.request<JsonOf<ChildBackupPickupsResponse>>({
    url: uri`/employee/children/${request.childId}/backup-pickups`.toString(),
    method: 'GET'
  })
  return json
}


/**
* Generated from evaka.core.backuppickup.BackupPickupController.updateBackupPickup
*/
export async function updateBackupPickup(
  request: {
    id: BackupPickupId,
    body: ChildBackupPickupContent
  }
): Promise<void> {
  const { data: json } = await client.request<JsonOf<void>>({
    url: uri`/employee/backup-pickups/${request.id}`.toString(),
    method: 'PUT',
    data: request.body satisfies JsonCompatible<ChildBackupPickupContent>
  })
  return json
}
